import { startCase } from 'lodash';

class FinancingMapperService {
    getFinancingApplicationFromState({ primaryApplicant, coApplicant, hasCoApplicant }) {
        const financingApplication = {
            financing: {
                CreditAppType: 'FCA',
                PrimaryApplicant: this.mapApplicant(primaryApplicant),
                CoApplicant: hasCoApplicant ? this.mapApplicant(coApplicant) : null,
            },
        };

        return financingApplication;
    }

    mapAddress({ address, monthCount, yearCount }) {
        if (address) {
            return {
                StreetNo: address.address ? address.address.substr(0, address.address.indexOf(' ')) : '',
                StreetName: address.address ? address.address.substr(address.address.indexOf(' ') + 1) : '',
                SuiteNo: address.address2,
                PostalCode: address.postalCode,
                City: address.city,
                Province: `CA-${address.province}`,
                YearsAtAddress: yearCount,
                MonthsAtAddress: monthCount,
                StreetType: null,
                AddressType: 'ST',
            };
        }
        return {};
    }

    mapApplicant({ personalInformations, residenceInformations, employmentInformations }) {
        return {
            GenderId: personalInformations.gender,
            FirstName: personalInformations.firstname,
            LastName: personalInformations.lastname,
            DateOfBirth: `${personalInformations.monthOfBirth}-${personalInformations.dayOfBirth}-${
                personalInformations.yearOfBirth
            }`,
            Phone: personalInformations.phoneNumber,
            Email: personalInformations.email,
            ...this.mapIncome(employmentInformations),
            CurrentAddress: this.mapAddress(residenceInformations),
            HomeOwnershipType: startCase(residenceInformations.housingType),
            CurrentEmployment: this.mapEmployment(employmentInformations),
            ...this.mapMortgage(residenceInformations),
        };
    }

    mapMortgage({ housingValues }) {
        if (housingValues) {
            return {
                HomeMortgageOwnership: housingValues.mortgageHolder,
                HomeMonthlyPayment: housingValues.monthlypayments,
                HomeMarketValue: housingValues.mortgageValue,
                HomeMortgageAmount: housingValues.mortgageAmount,
            };
        }
        return {};
    }

    mapEmployment(employmentInformations) {
        return {
            EmploymentStatus: employmentInformations.status,
            EmploymentType: employmentInformations.type,
            EmployerName: employmentInformations.employer,
            Occupation: employmentInformations.occupation,
            EmployerPhone: employmentInformations.phoneNumber,
            EmployerPhoneExt: employmentInformations.phoneExtension,
            EmployerDurationYears: employmentInformations.yearsAtEmployment,
            EmployerDurationMonths: employmentInformations.monthsAtEmployment,
            Address: {
                Province: `CA-${employmentInformations.province}`,
                AddressType: null,
                StreetNo: employmentInformations.streetNumber,
                StreetName: employmentInformations.streetName,
                StreetType: employmentInformations.streetType,
                StreetDirection: null,
                SuiteNo: employmentInformations.unitNumber,
                City: employmentInformations.city,
                PostalCode: employmentInformations.postalCode,
            },
        };
    }

    mapIncome({ incomeGross, incomes, otherIncome }) {
        return {
            IncomeGross: incomeGross,
            IncomeGrossBasis: incomes,
            ...this.mapOtherIncome(otherIncome),
        };
    }

    mapOtherIncome(otherIncome) {
        if (otherIncome) {
            return {
                OtherIncomeType: otherIncome.type,
                IncomeOther: otherIncome.amount,
                IncomeOtherBasis: otherIncome.frequency,
                IncomeOtherDescription: '',
            };
        }
        return {};
    }
}

export default new FinancingMapperService();



// WEBPACK FOOTER //
// ./src/services/FinancingMapperService/FinancingMapperService.js